import { type OrderPaymentMethod, OrderPaymentMethods } from '../../api/order';
import { getRequestContext } from '../requestContext';

export const getDefaultPaymentMethod = (): OrderPaymentMethod => {
    const {
        delivery: { disableOnlinePayment },
    } = getRequestContext();

    if (disableOnlinePayment) {
        return OrderPaymentMethods.CARD_ON_DELIVERY;
    }

    return OrderPaymentMethods.CARD_ONLINE;
};
